import useEscapeToClose from '../../hooks/useEscapeToClose';
import './ConfirmDialog.css';

// Popup de confirmacao generico (Tarefas 7.4/7.5, specs/skills/plan.md) -
// reaproveitado pelos dois fluxos de substituicao total de conteudo de
// skill: "Substituir skill" na tela "Detalhe da Skill" e a confirmacao de
// nome repetido em "Adicionar Skill". Nao havia nenhum popup de confirmacao
// de 2 botoes no projeto ate esta tarefa (so AlertsCustom, que e' so 1
// botao/"OK") - componente novo, pequeno e generico o bastante pra qualquer
// confirmacao futura fora do escopo de skills tambem. Textos sempre vem do
// chamador (sem fallback de traducao interno), para nao acoplar este
// componente a nenhum namespace de i18n especifico.
// `danger` (opcional, default false): usado so pela confirmacao de "Excluir"
// skill (SkillDetailView.js) - deixa o botao de confirmar vermelho em vez do
// azul padrao, sinalizando uma acao destrutiva/irreversivel. "Substituir
// skill" (Tarefas 7.4/7.5) e a confirmacao de nome repetido continuam sem
// passar essa prop, permanecendo azuis - so o botao de excluir deve ser
// vermelho, nao o componente inteiro.
export default function ConfirmDialog({ isOpen, title, message, confirmLabel, cancelLabel, onConfirm, onCancel, danger = false }) {
    // Achado de acessibilidade (specs/skills/plan.md, 2026-09-15): nenhum modal de Skills
    // respondia ao Esc - componente genérico, então este fix alcança todo uso dele.
    useEscapeToClose(onCancel, isOpen);

    if (!isOpen) return null;

    const handleOverlayClick = (event) => {
        if (event.target === event.currentTarget) onCancel();
    };

    return (
        <div className="modal-overlay-confirm-dialog" onClick={handleOverlayClick} data-testid="confirm-dialog-overlay">
            <div className="modal-content-confirm-dialog" data-testid="confirm-dialog">
                <p className="confirm-dialog-title">{title}</p>
                <p className="confirm-dialog-message">{message}</p>
                <div className="confirm-dialog-actions">
                    <button
                        type="button"
                        className="confirm-dialog-cancel-button"
                        onClick={onCancel}
                        data-testid="confirm-dialog-cancel"
                    >
                        {cancelLabel}
                    </button>
                    <button
                        type="button"
                        className={`confirm-dialog-confirm-button${danger ? ' confirm-dialog-confirm-button--danger' : ''}`}
                        onClick={onConfirm}
                        data-testid="confirm-dialog-confirm"
                    >
                        {confirmLabel}
                    </button>
                </div>
            </div>
        </div>
    );
}
